import { getModifierGroup, createModifierGroup, deleteModifierGroup, bulkCreateModifierGroups, updateModifierGroup, bulkUpdateModifierGroups, queryModifierGroups, bulkDeleteModifierGroups, countModifierGroups } from '@wix/ambassador-restaurants-menus-v1-item-modifier-group/http';
import { MAX_NUMBER_OF_MODIFIER_GROUPS_FROM_SERVER, getEntityChunks, orderEntitiesById } from './utils';
import { BaseAPIClient } from './BaseAPIClient';
export class ModifierGroupsClient extends BaseAPIClient {
  async getById(modifierGroupId) {
    const response = await this.request(getModifierGroup, {
      modifierGroupId
    });
    return response.data.modifierGroup;
  }
  async getBulk(args) {
    var _args$ids;
    let idChunks;
    let modifierGroups = [];
    let pagingMetadata;
    if (args != null && (_args$ids = args.ids) != null && _args$ids.length) {
      idChunks = getEntityChunks(args == null ? void 0 : args.ids, MAX_NUMBER_OF_MODIFIER_GROUPS_FROM_SERVER);
      const modifierGroupsInChunks = await Promise.all(idChunks.map(async chunk => {
        const query = {
          filter: {
            id: {
              $in: chunk || []
            }
          }
        };
        const {
          data
        } = await this.request(queryModifierGroups, {
          query
        });
        return data.modifierGroups || [];
      }));
      modifierGroups.push(...modifierGroupsInChunks.flatMap(modifierGroup => modifierGroup));
      const modifierGroupsByClientOrder = orderEntitiesById(args.ids, modifierGroups);
      modifierGroups = modifierGroupsByClientOrder;
    } else {
      const {
        data
      } = await this.request(queryModifierGroups, {
        query: {
          cursorPaging: args == null ? void 0 : args.paging
        }
      });
      modifierGroups = data.modifierGroups;
      pagingMetadata = data.pagingMetadata;
    }
    return {
      data: modifierGroups || [],
      pagingMetadata
    };
  }
  async create(modifierGroup) {
    const response = await this.request(createModifierGroup, {
      modifierGroup
    });
    return response.data.modifierGroup;
  }
  async update(modifierGroup) {
    const response = await this.request(updateModifierGroup, {
      modifierGroup
    });
    return response.data.modifierGroup;
  }
  async delete(modifierGroupId) {
    const response = await this.request(deleteModifierGroup, {
      modifierGroupId
    });
    return response.data;
  }
  async bulkDelete(modifierGroupIds) {
    const response = await this.request(bulkDeleteModifierGroups, {
      ids: modifierGroupIds
    });
    return response.data;
  }
  async bulkCreate(modifierGroups) {
    const response = await this.request(bulkCreateModifierGroups, {
      modifierGroups,
      returnEntity: true
    });
    const results = response.data.results || [];
    return results.map(result => result.modifierGroup);
  }
  async bulkUpdate(modifierGroups) {
    const response = await this.request(bulkUpdateModifierGroups, {
      modifierGroups: modifierGroups.map(modifierGroup => ({
        modifierGroup
      })),
      returnEntity: true
    });
    const results = response.data.results || [];
    return results.map(result => result.modifierGroup);
  }
  async query(query) {
    const {
      data: {
        modifierGroups = [],
        pagingMetadata
      }
    } = await this.request(queryModifierGroups, {
      query
    });
    return {
      data: modifierGroups,
      pagingMetadata
    };
  }
  async countModifierGroups(filter) {
    const response = await this.request(countModifierGroups, {
      filter
    });
    return response.data.count;
  }
}
//# sourceMappingURL=ModifierGroupsClient.js.map